// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || "https://my-project-fa1d5-default-rtdb.firebaseio.com"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize all services
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Initialize Realtime Database only if databaseURL is provided
let database = null;
try {
  console.log('Checking databaseURL:', firebaseConfig.databaseURL);
  if (firebaseConfig.databaseURL) {
    database = getDatabase(app);
    console.log('✅ Firebase Realtime Database initialized successfully');
  } else {
    console.warn('⚠️ Firebase Realtime Database URL not configured. Employee features will not work.');
    console.warn('Please add REACT_APP_FIREBASE_DATABASE_URL to your .env file and restart the server.');
  }
} catch (error) {
  console.error('❌ Error initializing Realtime Database:', error);
}

// Export everything at once
export { app, analytics, auth, db, storage, database };
